import { FC } from 'react';
import { Box, styled } from '@mui/material';
import { Close } from '@mui/icons-material';
import { TrackerIconButton } from '../components/TrackerButtonWrapper';
import { ButtonName } from '../constants';

export const StyledHeaderContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  height: '100%',
  padding: theme.spacing(2),
  paddingLeft: theme.spacing(3),
}));

export type ModalHeaderWithExitButtonProps = {
  title: string;
};

export const ModalHeaderWithExitButton: FC<ModalHeaderWithExitButtonProps> = ({
  title,
}) => {
  return (
    <StyledHeaderContainer data-testId="confirmation-modal-header">
      {title}
      <TrackerIconButton
        buttonName={ButtonName.EscapeKey}
        onClick={(e) => {
          const event = new KeyboardEvent('keydown', {
            key: 'Escape',
            bubbles: true,
          });
          e?.target.dispatchEvent(event);
        }}
      >
        <Close fontSize="small" />
      </TrackerIconButton>
    </StyledHeaderContainer>
  );
};
